import type { EvaluationData, EvaluationTemplate, EvaluationUser } from './api';

export const isAutomatedEvaluation = (item: { createdBy?: string | number | null; evaluatedUserId?: string | number | null }) => {
    return !item.createdBy || item.createdBy === item.evaluatedUserId;
};

export function calculateScore(template: EvaluationTemplate, data: EvaluationData) {
    if (!template || !data) return 0;

    const scores = (template.questionnaire || [])
        .filter((q: { kind?: string }) => q.kind === 'rating')
        .reduce((score: number[], q: { key?: string }) => {
            const num = parseInt(String(data[q.key || ''] || '0'), 10) || 0;
            if (Number.isNaN(num) || num < 1 || num > 6) {
                return score;
            }
            return score.concat([num]);
        }, []);

    const sum = scores.reduce((a: number, b: number) => a + b, 0);
    if (sum === 0) {
        return '';
    }

    return (sum / scores.length || 0).toFixed(2);
}

export const formatUserName = (user: EvaluationUser | null | undefined) => {
    return user ? `${user.firstName} ${user.lastName}`.trim() || user.personalUsername || user.email || `${user.id}` : '';
};
